import { Box, IconButton } from '@mui/material';
import { DynamicIcon } from 'src/components';
import { useGlobalStore } from 'src/store';
import { useScreenDimensions } from 'src/utils/system';

export const DrawerCloseControl = () => {
  const navbar = useGlobalStore.use.navbar();
  const setNavbar = useGlobalStore.use.setNavbar();

  const { isMobile } = useScreenDimensions();

  const showNavBarOpenButton = !navbar.isOpen && !isMobile;

  return (
    <Box height="2.45rem">
      {Boolean(showNavBarOpenButton) && (
        <IconButton
          onClick={() => setNavbar({ isOpen: true })}
          sx={{
            ...(!showNavBarOpenButton && {
              visibility: 'hidden',
              pointerEvents: 'none',
              position: 'absolute',
              width: 0,
              height: 'auto',
            }),
          }}
        >
          <DynamicIcon name="left_panel_open" />
        </IconButton>
      )}
    </Box>
  );
};
